import axios from 'axios'
import { castAttributesForCamelCase } from '../../modules/string_converter'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../modules/mutations.js'
import { i18n } from '../../plugins/i18n'

export const companiesProducts = {
  namespaced: true,
  state: {
    data: null,
    meta: {},
    formValues: {},
    loading: false,
    checkProductIds: [],
    bulkSetProducts: [],
    bulkSetProductsForPreview: []
  },
  getters: {
    loading(state) {
      return state.loading
    },
    storeTotalCount(state) {
      return state.formValues.stores ? state.formValues.stores.length : 0
    },
    bulkSetProductsForPreview(state) {
      return state.bulkSetProductsForPreview
    },
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readProductsSuccess(state, payload) {
      state.data = payload.data.map(v => {
        const result = castAttributesForCamelCase(v.attributes)
        result.gmbSyncResult = castAttributesForCamelCase(result.gmbSyncResult)
        result.id = v.id
        return result
      })
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    },
    setProductId(state, id) {
      if (state.checkProductIds.includes(id)) {
        state.checkProductIds = state.checkProductIds.filter(v => v !== id)
      } else {
        state.checkProductIds = [...state.checkProductIds, id]
      }
    },
    setProductsForBulkSet(state) {
      state.bulkSetProducts = state.data.filter(v => state.checkProductIds.includes(v.id))
    },
    initCheckProducts(state) {
      state.checkProductIds = []
    },
    setMeta(state, meta) {
      state.meta = castAttributesForCamelCase(meta)
    },
    createPreviewSuccess(state, payload) {
      state.bulkSetProductsForPreview = castAttributesForCamelCase(payload.data)
      state.loading = false
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    setProductId({ commit }, id) {
      commit('setProductId', id)
    },
    setProductsForBulkSet({ commit }) {
      commit('setProductsForBulkSet')
    },
    readProducts({ commit, rootState }, query) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/products/search.json', query)
        .then(res => {
          commit('readProductsSuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readProductsForFilter({ commit, rootState }, query) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/products/search.json', query)
        .then(res => {
          commit('setMeta', res.data.meta)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    deleteProduct({ commit, rootState }, id) {
      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/products/' + id)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.product.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    async createPreview({ rootState, commit }, payload) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/products/bulk_operations/previews', payload)
        .then((res) => {
          commit('createPreviewSuccess', res.data)
          commit('stopLoading')
          return true
        }).catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
  }
}
